export default [
  { id: 1, description: "Word Document" },
  { id: 2, description: "Markdown" },
  { id: 3, description: "Extra File" },
];
